import { apiClient } from './client';
import { ExecutionResponse, StepExecutionResponse, PagedResponse } from '../types';

export interface ExecutionFilters {
  flowId?: string;
  status?: string;
  customerId?: string;
  startedFrom?: string;
  startedTo?: string;
  hasError?: boolean;
  errorContains?: string;
  parentExecutionId?: string;
  topLevelOnly?: boolean;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
  page?: number;
  pageSize?: number;
}

export const getExecutions = (filters: ExecutionFilters = {}) => {
  const params = new URLSearchParams();
  if (filters.flowId)    params.set('flowId', filters.flowId);
  if (filters.status)    params.set('status', filters.status);
  if (filters.customerId) params.set('customerId', filters.customerId);
  if (filters.startedFrom) params.set('startedFrom', filters.startedFrom);
  if (filters.startedTo)   params.set('startedTo', filters.startedTo);
  if (filters.hasError != null) params.set('hasError', String(filters.hasError));
  if (filters.errorContains) params.set('errorContains', filters.errorContains);
  if (filters.parentExecutionId) params.set('parentExecutionId', filters.parentExecutionId);
  if (filters.topLevelOnly != null) params.set('topLevelOnly', String(filters.topLevelOnly));
  if (filters.sortBy)    params.set('sortBy', filters.sortBy);
  if (filters.sortDir)   params.set('sortDir', filters.sortDir);
  if (filters.page != null)     params.set('page', String(filters.page));
  if (filters.pageSize != null) params.set('pageSize', String(filters.pageSize));
  return apiClient.get<PagedResponse<ExecutionResponse>>(`/api/executions?${params}`).then(r => r.data);
};

export const getExecution = (id: string) =>
  apiClient.get<ExecutionResponse>(`/api/executions/${id}`).then(r => r.data);

export const getExecutionSteps = (id: string) =>
  apiClient.get<StepExecutionResponse[]>(`/api/executions/${id}/steps`).then(r => r.data);

export const replayExecution = (id: string) =>
  apiClient.post<{ id: string }>(`/api/executions/${id}/replay`).then(r => r.data);

export const getDlq = () =>
  apiClient.get<ExecutionResponse[]>('/api/executions/dlq').then(r => r.data);

export const replayDlq = (id: string) =>
  apiClient.post<{ id: string }>(`/api/executions/dlq/${id}/replay`).then(r => r.data);
